import React from 'react';

const Terms = () => {
	return (
		<>
			<title>Terms and Conditions - FlickScout.com</title>
			<meta name="description" content="Terms and conditions for using FlickScout - the AI-powered movie recommendation platform." />
			
			<div className="container mx-auto px-4 py-12">
				<div className="max-w-4xl mx-auto">
					<h1 className="text-4xl font-bold mb-8 text-center">Terms and Conditions</h1>
					
					<div className="bg-gray-800 rounded-lg p-8 mb-8 shadow-lg">
						<p className="text-gray-300 mb-6">
							Last updated: {new Date().toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
						<p className="text-gray-300 mb-6">
							By accessing or using FlickScout, you agree to be bound by these Terms and Conditions and our Privacy Policy. 
							If you disagree with any part of the terms, you may not access the service.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">2. Description of Service</h2>
						<p className="text-gray-300 mb-6">
							FlickScout provides an AI-powered movie recommendation service that suggests films based on user descriptions and preferences.
							We reserve the right to modify or discontinue the service at any time without notice.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">3. User Responsibilities</h2>
						<p className="text-gray-300 mb-6">
							Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.
							You agree not to use the service for any illegal or unauthorized purpose and to comply with all applicable laws.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">4. Intellectual Property</h2>
						<p className="text-gray-300 mb-6">
							The service and its original content, features, and functionality are owned by FlickScout and are protected by international copyright, 
							trademark, patent, trade secret, and other intellectual property laws.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">5. Third-Party Links</h2>
						<p className="text-gray-300 mb-6">
							Our service may contain links to third-party websites or services that are not owned or controlled by FlickScout.
							We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">6. Limitation of Liability</h2>
						<p className="text-gray-300 mb-6">
							In no event shall FlickScout, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, 
							incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other 
							intangible losses, resulting from your access to or use of or inability to access or use the service.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">7. Disclaimer</h2>
						<p className="text-gray-300 mb-6">
							Your use of the service is at your sole risk. The service is provided on an "AS IS" and "AS AVAILABLE" basis. 
							The service is provided without warranties of any kind, whether express or implied, including, but not limited to, 
							implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">8. Governing Law</h2>
						<p className="text-gray-300 mb-6">
							These Terms shall be governed and construed in accordance with the laws, without regard to its conflict of law provisions.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">9. Changes to Terms</h2>
						<p className="text-gray-300 mb-6">
							We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, 
							we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change 
							will be determined at our sole discretion.
						</p>
						
						<h2 className="text-2xl font-semibold mb-4">10. Contact Us</h2>
						<p className="text-gray-300">
							If you have any questions about these Terms, please contact us.
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default Terms;


